import { CSSProperties } from 'react';
import { IconType } from '.';

interface EyeSlashIcon extends IconType {
  style?: CSSProperties;
}

export default function EyeSlashIcon({ color = '#000000', className = '', height = 14.095, style, width = 17.618 }: EyeSlashIcon) {
  return (
    <svg width={width} height={height} viewBox="0 0 17.618 14.095" style={style} className={className}>
      <path
        fill={color}
        d="M1.063.135A.661.661,0,0,0,.248,1.175l16.3,12.773a.661.661,0,0,0,.815-1.041l-2.9-2.268a10.968,10.968,0,0,0,2.2-3.259.875.875,0,0,0,0-.677A10.962,10.962,0,0,0,14.1,3.094,7.734,7.734,0,0,0,8.8.875a7.518,7.518,0,0,0-4.66,1.674ZM5.219,3.391A6.124,6.124,0,0,1,8.8,2.2a6.444,6.444,0,0,1,4.4,1.864,9.8,9.8,0,0,1,2.166,2.981A9.759,9.759,0,0,1,13.42,9.819L11.939,8.658A3.526,3.526,0,0,0,6.488,4.385L5.219,3.391Zm5.646,4.426L8.622,6.059A1.762,1.762,0,0,0,8.8,5.28a1.788,1.788,0,0,0-.055-.44H8.8a2.2,2.2,0,0,1,2.062,2.979Zm.259,3.587a5.856,5.856,0,0,1-2.321.482,6.444,6.444,0,0,1-4.4-1.864A9.8,9.8,0,0,1,2.235,7.042,9.282,9.282,0,0,1,3.32,5.258L2.282,4.44A10.414,10.414,0,0,0,.944,6.7a.875.875,0,0,0,0,.677A10.962,10.962,0,0,0,3.5,10.989a7.734,7.734,0,0,0,5.3,2.219,7.236,7.236,0,0,0,3.474-.895L11.124,11.4ZM5.28,7.042a3.526,3.526,0,0,0,4.575,3.364L8.308,9.189A2.215,2.215,0,0,1,6.83,8.024L5.285,6.808c-.006.077-.008.154-.008.234Z"
        transform="translate(0.006 0.006)"
      />
    </svg>
  );
}
